<template>
    <div class="spinner">
        <span>{{ message }}</span>
        <br />
        <br />
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</template>

<script>

export default ({
    name: 'activity-indicator',
    props: {
        message: String
    },
    setup(props, ctx) {
        const message = ref(props.message);


        //====================== onMounted ===========================

        onMounted(() => {

        });

        //====================== return ===========================

        return {
            message
        }
    },
})
</script>
